import React from 'react';
import { textStyles, truncateStyles } from "../Text";
import { IconButton } from "../Button";
import styled from 'styled-components';
import { theme } from "../../theme";
import { AnimatePresence, motion } from 'framer-motion';
import { SIZE_TRANSITION } from "./sheet-transitions";
export function SheetHead(_ref) {
  var title = _ref.title,
      id = _ref.id,
      onRequestClose = _ref.onRequestClose,
      closeIcon = _ref.closeIcon,
      collapseButtonLabel = _ref.collapseButtonLabel;
  return /*#__PURE__*/React.createElement(SheetContainer, null, /*#__PURE__*/React.createElement(RelativeTitle, null, /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, /*#__PURE__*/React.createElement(AbsTitle, {
    key: id,
    transition: SIZE_TRANSITION,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement(SheetTitle, {
    id: id
  }, title)))), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    variant: "link",
    label: collapseButtonLabel,
    icon: closeIcon,
    onClick: onRequestClose
  }));
}
var SheetContainer = styled.div.withConfig({
  displayName: "SheetHead__SheetContainer",
  componentId: "vapor__sc-19p9d50-0"
})(["border-bottom:1px solid ", ";height:", ";display:flex;align-items:center;padding:0 ", ";user-select:none;flex-shrink:0;"], theme.colors.palette.grey20, theme.spaces[48], theme.spaces[16]);
var SheetTitle = styled(motion.span).withConfig({
  displayName: "SheetHead__SheetTitle",
  componentId: "vapor__sc-19p9d50-1"
})(["", ";", ";padding-right:", ";"], textStyles.link, truncateStyles, theme.spaces[4]);
var AbsTitle = styled(motion.div).withConfig({
  displayName: "SheetHead__AbsTitle",
  componentId: "vapor__sc-19p9d50-2"
})(["position:absolute;top:0;left:0;bottom:0;right:0;display:flex;align-items:center;overflow:hidden;"]);
var RelativeTitle = styled.div.withConfig({
  displayName: "SheetHead__RelativeTitle",
  componentId: "vapor__sc-19p9d50-3"
})(["position:relative;flex:1;overflow:hidden;align-self:stretch;"]);